import { render, staticRenderFns } from "./InsertUserData.vue?vue&type=template&id=33920eb8&scoped=true&"
import script from "./InsertUserData.vue?vue&type=script&lang=js&"
export * from "./InsertUserData.vue?vue&type=script&lang=js&"
import style0 from "./InsertUserData.vue?vue&type=style&index=0&id=33920eb8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33920eb8",
  null
  
)

export default component.exports